import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'ag-add-patron-error',
  templateUrl: './add-patron-error.dialog.html',
  styleUrls: ['./add-patron-error.dialog.scss'],
})
export class AddPatronErrorDialog implements OnInit {
  name: string;
  messages: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddPatronErrorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.name = this.data.name;
    this.messages = this.data.messages;
  }
}
